const updates = [
  {
    date: '2026-07-31',
    title: '蚂蚁影视APP v3.8.2 版本更新发布',
    desc: '新增AI智能推荐算法，根据观影偏好精准推送影片；优化播放器内核，启动速度提升40%。',
    tag: '版本更新',
    tagStyle: 'bg-primary-500/15 text-primary-400',
  },
  {
    date: '2026-07-28',
    title: '《暗夜追踪》全网首播上线',
    desc: '年度最受期待的悬疑大片正式登陆蚂蚁影视，上线首日播放量突破800万次。',
    tag: '新片上线',
    tagStyle: 'bg-accent-500/15 text-accent-400',
  },
  {
    date: '2026-07-25',
    title: '4K修复版港片经典专题上线',
    desc: '首批50部经典港片完成4K修复，《英雄本色》《重庆森林》等影史名作高清重现。',
    tag: '专题上线',
    tagStyle: 'bg-green-500/15 text-green-400',
  },
  {
    date: '2026-07-22',
    title: '蚂蚁影视暑期观影活动开启',
    desc: '看片攒积分兑好礼，每日签到领会员权益。活动期间上线多部暑期档新片，一次看过瘾。',
    tag: '平台活动',
    tagStyle: 'bg-primary-500/15 text-primary-400',
  },
  {
    date: '2026-07-18',
    title: '纪录片频道内容全面升级',
    desc: '引进BBC、国家地理等顶级制作方版权内容，新增4K自然纪录片专区，视觉盛宴即刻开启。',
    tag: '内容升级',
    tagStyle: 'bg-accent-500/15 text-accent-400',
  },
  {
    date: '2026-07-15',
    title: '蚂蚁影视服务器全面扩容',
    desc: '新增亚太区三个CDN节点，海外用户访问速度提升60%，全球观影体验全面优化。',
    tag: '技术升级',
    tagStyle: 'bg-secondary-500/15 text-secondary-400',
  },
  {
    date: '2026-07-10',
    title: '《长安十二时辰》第二季官宣定档',
    desc: '原班人马重磅回归，8月15日起每周五晚8点蚂蚁影视独家播出，预约已破百万。',
    tag: '剧集定档',
    tagStyle: 'bg-primary-500/15 text-primary-400',
  },
  {
    date: '2026-07-05',
    title: '首届蚂蚁影视原创短片大赛启动',
    desc: '面向全国青年导演征集原创作品，最高奖金10万元，优秀作品将获得全平台推广资源。',
    tag: '官方活动',
    tagStyle: 'bg-accent-500/15 text-accent-400',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading">
            最新快讯
          </h2>
          <p className="mt-3 text-foreground-400 text-sm">
            蚂蚁影视最新动态与内容更新一览
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300/40 hidden sm:block"></div>

          <div className="space-y-5">
            {updates.map((item, i) => (
              <div key={i} className="flex gap-4 sm:gap-6 items-start">
                <div className="hidden sm:flex items-center justify-center flex-shrink-0 w-10 h-10 rounded-full bg-background-50 border-2 border-background-300/40 relative z-10">
                  <span className="w-2.5 h-2.5 rounded-full bg-primary-500"></span>
                </div>
                <div className="flex-1 bg-background-50 border border-background-300/30 rounded-xl p-4 sm:p-5 hover:border-primary-500/30 transition-all duration-300 cursor-pointer min-w-0">
                  <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 mb-2">
                    <span className={`inline-block px-2.5 py-1 text-[11px] font-medium rounded-md whitespace-nowrap self-start ${item.tagStyle}`}>
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.date}</span>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-100">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 text-xs text-foreground-500 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}